import React from 'react'
import Admin from './Admin'
import "../../styles/admin.css";

export default function AdminEmails() {

    const sendMailStatMatches = () => {
        if (!window.confirm("Biztosan el szeretnéd küldeni ezt az email x embernek?")) return;

        //EMAIL ELKÜLDÉSE AZ ÖSSZES FELHASZNÁLÓNAK A STATISZTIKAI MECCSEKRŐL
        fetch("https://focifanatik.hu/api/sendMail.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                type: "sendMailStatMatches",
                to: "allUser@gmail.com"
            })
        })

    }

    const sendMailVoteMatches = () => {
        if (!window.confirm("Biztosan el szeretnéd küldeni ezt az email x embernek?")) return;

        //EMAIL ELKÜLDÉSE AZ ÖSSZES FELHASZNÁLÓNAK A SZAVAZÁS MECCSEKRŐL
        fetch("https://focifanatik.hu/api/sendMail.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                type: "sendMailVoteMatches",
                to: "allUser@gmail.com"
            })
        })

    }

    return (
        <div className='admin-page'>
            <Admin />
            <main className='admin-content'>
                <header className='admin-header'>
                    <h3>Emailek kezelésee</h3>
                </header>

                <main className='admin-main'>

                    <div className='admin-email-buttons'>

                        <main className='admin-email-button'>
                            <p>Email küldés az összes felhasználónak az elérhető statisztikai mérkőzésekről</p>
                            <button className='btn-sendMail' onClick={sendMailStatMatches}>
                                Email küldése a statisztikai merkőzésekről.
                            </button>
                        </main>

                        <main className='admin-email-button'>
                            <p>Email küldés az összes felhasználónak a szavazás mérkőzéseiről</p>
                            <button className='btn-sendMail' onClick={sendMailVoteMatches}>
                                Email küldése a szavazós mérkőzésekről.
                            </button>
                        </main>

                    </div>



                </main>

            </main>
        </div>
    )
}
